import { NOTIFY_ERROR } from 'src/vuex/modules/snackbar/types'
import { getPartners, getStrategies } from '../apiCalls'
import * as types from './types'

export default {
  [types.CHANGE_PAGINATION]({ commit }, newPagination) {
    commit(types.SET_PAGINATION, newPagination)
  },
  [types.CHANGE_FILTERS]({ commit, dispatch }, { key, value }) {
    commit(types.SET_FILTERS, {
      key,
      value
    })
    dispatch(types.GET_STRATEGIES_ETR)
  },
  [types.RESET_PAGINATION]({ state, dispatch }) {
    dispatch(types.CHANGE_PAGINATION, {
      ...state.pagination,
      page: 1
    })
  },
  [types.GET_PARTNERS]: async function ({ commit }) {
    try {
      const partners = await getPartners()
      commit(types.SET_PARTNERS, partners.results)
    } catch (err) {
      console.error(err)
      commit(types.SET_PARTNERS, [])
    }
  },
  [types.GET_STRATEGIES_ETR]: async ({ commit, getters, dispatch }) => {
    commit(types.SET_IS_ETR_LOADING, true)

    try {
      const params = getters[types.PARAMS_TO_SEND]
      const strategiesETR = await getStrategies(params)
      commit(types.SET_STRATEGIES_ETR, strategiesETR.result)
      commit(types.SET_TOTAL_ITEMS, strategiesETR.summary.total_items)
    } catch (err) {
      console.error(err)
      dispatch(NOTIFY_ERROR, { message: err.response.data })
      commit(types.SET_STRATEGIES_ETR, [])
      commit(types.SET_TOTAL_ITEMS, 0)
    } finally {
      commit(types.SET_IS_ETR_LOADING, false)
    }
  },
  [types.GET_STRATEGIES_ETP]: async ({ commit }) => {
    commit(types.SET_IS_ETP_LOADING, true)

    try {
      const strategiesETP = await getStrategies({ product: 'ETP' })
      commit(types.SET_STRATEGIES_ETP, strategiesETP)
    } catch (err) {
      console.error(err)
      dispatch(NOTIFY_ERROR, { message: err.response.data })
      commit(types.SET_STRATEGIES_ETP, [])
    } finally {
      commit(types.SET_IS_ETP_LOADING, false)
    }
  }
}
